import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'

import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline, StyledEngineProvider } from '@mui/material'

// routing
import router from 'routes'

// defaultTheme
import themes from 'themes'

// project imports
import NavigationScroll from 'layout/NavigationScroll'
import { LoadingProvider } from 'contexts/LoadingContext'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { UppyProvider } from 'contexts/UppyContext'
import { ConfirmDialogProvider } from 'contexts/ConfirmDialogContext'
import { assetRequest } from './services/request'
// ==============================|| APP ||============================== //

const App = () => {
  const [init, setInit] = useState(false)
  const customization = useSelector((state) => state.customization)
  const [theme, setTheme] = useState(null)
  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const res = await assetRequest.get('/api/services/assets/stream/themes/dark.json')
        const appTheme = themes(customization, res)
        setTheme(appTheme)
      } catch (error) {
        console.error('Failed to fetch theme:', error)
        // fallback to local default theme nếu cần
        setTheme(themes(customization))
      }
    }
    const fetchListApps = async () => {
      try {
        const res = await assetRequest.get('/api/services/assets/stream/configs/menu-apps.json')
        if (res) {
          const title = res.apps.filter((app) => app.id === 'cube')[0].name
          document.title = title ? title : 'Cube'
        }
      } catch (error) {
        console.error('Failed to fetch apps:', error)
      }
    }
    fetchTheme()
    fetchListApps()
    setInit(true)
  }, [customization])
  if (!theme || !init) return null
  return (
    <StyledEngineProvider injectFirst>
      <ConfirmDialogProvider>
        <LoadingProvider>
          <UppyProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <NavigationScroll>
                  <RouterProvider router={router} />
                </NavigationScroll>
              </ThemeProvider>
            </LocalizationProvider>
          </UppyProvider>
        </LoadingProvider>
      </ConfirmDialogProvider>
    </StyledEngineProvider>
  )
}

export default App
